import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { AuthLayout } from "@/pages/Login";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ loading: true });
  const [pw, setPw] = useState({ a: "", b: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/auth/reset-link", { params: { token }, skipRefresh: true }).then((r) => setState({ email: r.data.email, min: r.data.min_length }))
      .catch((e) => setState({ error: errMsg(e) }));
  }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.a !== pw.b) { toast.error("The passwords do not match"); return; }
    setBusy(true);
    try { const { data } = await api.post("/auth/reset-link", { token, new_password: pw.a }, { skipRefresh: true }); setState({ done: data.message }); }
    catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <AuthLayout title="Set a new password" subtitle={state.email ? `For ${state.email}` : "CASURECO II account"}>
      {state.loading ? <p className="text-sm text-slate-500">Checking your link…</p>
        : state.error || state.done ? (
          <div className="space-y-4" data-testid="reset-result">
            <p className={state.error ? "text-sm text-rose-700" : "text-sm text-emerald-700"}>{state.error || state.done}</p>
            <Link to="/login" className="text-sm underline" data-testid="reset-back-to-login">Go to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
            <div className="space-y-1"><Label>New password</Label><Input type="password" value={pw.a} onChange={(e) => setPw({ ...pw, a: e.target.value })} data-testid="reset-new-password" /></div>
            <div className="space-y-1"><Label>Confirm password</Label><Input type="password" value={pw.b} onChange={(e) => setPw({ ...pw, b: e.target.value })} data-testid="reset-confirm-password" /></div>
            <p className="text-xs text-slate-500">At least {state.min} characters, with letters and numbers. You will be signed out everywhere after the change.</p>
            <Button type="submit" className="w-full" disabled={busy || pw.a.length < state.min} data-testid="reset-submit">Save new password</Button>
          </form>
        )}
    </AuthLayout>
  );
}
